module.exports = __webpack_public_path__ + "img/4.a8904d2f.png";